
function clickHref(url) {
    window.location.href = url;
  }
  function addScroll() {
    document.body.classList.add('no-scroll');
  }
 function hrefOpen(url) {
   window.open(url, '_blank');
  }
$('.footer ').hide()
function modalTag(a, b) {
  // 假设 'a' 是一个选择器或 jQuery 对象，'b' 是索引
  let $items = $(a).find('.modal-item');
  
  // 移除所有项的 'active' 类
  $items.removeClass('active');
  
  // 为指定索引的项添加 'active' 类
  $items.eq(b).addClass('active');
  $('.rules-tips').hide()
  $('.rules-reward').hide()
  if(b === 0) {
    $('.rules-tips').show()
  } else if(b === 1){
    $('.rules-reward-1').show()
  } else if(b === 2){
    $('.rules-reward-2').show()
  }
}
function closeModel(dom) {
  $('.giftList-list').scrollTop(0);
  $('#drawsNumberValue').val('')
  document.body.classList.remove('no-scroll');
  $(dom).hide()
}
 function getUrl(url) {
    if(!url) return ''
    return "https://nxtcity.nxtbrands.com/nxt/api/" + url
  }
  function gif1List(num) {
    if(num === 6) {
      $.ajax({
       url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/prize/list",
       type: "GET",
       data: {
         lotteryId:1 ,
         prizeType:num,
         getNum:5 ,
       }, 
       headers: { // 更正这里
          'X-DATA-VERSION-ID': window.dataVersionId.dataVersionId
        },
       dataType: "json", 
       success: function (result) {
         const {prizeList} = result
          gifListType(2, 1, prizeList)
        }
      })
  } else {
    gifListType(num, 1, [])
  }
}
function gifListType(num, type, array) {
   let firstArray = array
   $.ajax({
     url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/prize/list",
     type: "GET",
     data: {
       lotteryId:1 ,
       prizeType:num,
       getNum:5 ,
     }, 
     headers: { // 更正这里
        'X-DATA-VERSION-ID': window.dataVersionId.dataVersionId
      },
     dataType: "json", 
     success: function (result) {
       const {prizeList} = result
       firstArray.push(...prizeList)
       let array = firstArray
       let array2 = firstArray
       array.push(null,null,null,null,null)
       array.forEach((res, index)=>{
         if(res) {
           $('#gift1 .lucky-gift1-item').eq(index).css({
              'background-image': 'url(' + res.imageUrl + ')'
           });
         } else {
           $('#gift1 .lucky-gift1-item').eq(index).css({
              'background-image': ''
           });
         }
       })
        array2.push(null,null)
       array2.forEach((res, index)=>{
         console.log($('#mobile-gift1 .lucky-gift1-item')[index])
         if(res) {
           $('#mobile-gift1 .lucky-gift1-item').eq(index).css({
              'background-image': 'url(' + res.imageUrl + ')'
           });
         } else {
           $('#mobile-gift1 .lucky-gift1-item').eq(index).css({
              'background-image': ''
           });
         }
       })
    }
  })
}
function gif2ListType(num, type, array) {
  let firstArray = array
   $.ajax({
     url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/prize/list",
     type: "GET",
     data: {
       lotteryId:2 ,
       prizeType:num,
       getNum:5 ,
     }, 
     headers: { // 更正这里
        'X-DATA-VERSION-ID': window.dataVersionId.dataVersionId
      },
     dataType: "json", 
     success: function (result) {
       const {prizeList} = result
       firstArray.push(...prizeList)
       let array = firstArray
       let array2 = firstArray
       array.push(null,null,null,null,null)
       array.forEach((res, index)=>{
         if(res) {
           $('#gift2 .lucky-gift1-item').eq(index).css({
              'background-image': 'url(' + res.imageUrl + ')'
           });
         } else {
           $('#gift2 .lucky-gift1-item').eq(index).css({
              'background-image': ''
           });
         }
       })
        array2.push(null,null)
       array2.forEach((res, index)=>{
         console.log($('#mobile-gift2 .lucky-gift1-item')[index])
         if(res) {
           $('#mobile-gift2 .lucky-gift1-item').eq(index).css({
              'background-image': 'url(' + res.imageUrl + ')'
           });
         } else {
           $('#mobile-gift2 .lucky-gift1-item').eq(index).css({
              'background-image': ''
           });
         }
       })
    }
  })
}
function dataList(params, arr) {
    $.ajax({
       url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/prize/list",
       type: "GET",
       data: {
         lotteryId:1 ,
         blindBoxType:params,
         getNum:5 ,
       }, 
       headers: { // 更正这里
          'X-DATA-VERSION-ID': window.dataVersionId.dataVersionId
        },
       dataType: "json", 
       success: function (result) {
         const {prizeList} = result
         console.log('arr', arr)
         prizeList.push(...arr)
         let array = prizeList
         let array2 = prizeList
         array.push(null,null,null,null,null)
         array.forEach((res, index)=>{
           if(res) {
             $('#gift1 .lucky-gift1-item').eq(index).css({
                'background-image': 'url(' + res.imageUrl + ')'
             });
           } else {
             $('#gift1 .lucky-gift1-item').eq(index).css({
                'background-image': ''
             });
           }
         })
        array2.push(null,null)
         array2.forEach((res, index)=>{
           console.log($('#mobile-gift1 .lucky-gift1-item')[index])
           if(res) {
             $('#mobile-gift1 .lucky-gift1-item').eq(index).css({
                'background-image': 'url(' + res.imageUrl + ')'
             });
           } else {
             $('#mobile-gift1 .lucky-gift1-item').eq(index).css({
                'background-image': ''
             });
           }
         })
       }
    })
}
 function gif2List(num) {
    if(num === 6) {
      $.ajax({
       url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/prize/list",
       type: "GET",
       data: {
         lotteryId:2 ,
         prizeType:num,
         getNum:5 ,
       }, 
       headers: { // 更正这里
          'X-DATA-VERSION-ID': window.dataVersionId.dataVersionId
        },
       dataType: "json", 
       success: function (result) {
         const {prizeList} = result
          gif2ListType(2, 1, prizeList)
        }
      })
  } else {
    gif2ListType(num, 1, [])
  }
}
  function giftChange(type, num, zIndex) {
    var $items = $('.lucky-gift1-title-right-list').eq(type).find('.lucky-gift1-title-right-item');
    
    // 移除所有项的 'active' 类名
    $items.removeClass('active');
    
    // 给特定索引的项添加 'active' 类名
    $items.eq(zIndex-1).addClass('active');
    if(type === 1) {
      return gif2List(num)
    }
    return gif1List(num)
  }
  function giftMobileChange(type, num, zIndex) {
    var $items = $('.lucky-mobile-main .lucky-gift1-title-right-list').eq(type).find('.lucky-gift1-title-right-item');
    
    // 移除所有项的 'active' 类名
    $items.removeClass('active');
    
    // 给特定索引的项添加 'active' 类名
    $items.eq(zIndex).addClass('active');
    if(type === 1) {
      return gif2List(num)
    }
    return gif1List(num)
  }


$(document).ready(function() {
   document.querySelectorAll('.lucky-tag-item img').forEach(function(img) {
      img.addEventListener('mouseenter', function() {
        img.classList.add('shake');
        
        // 1秒后移除shake类
        setTimeout(function() {
          img.classList.remove('shake');
        }, 1000);
      });
    });
    $('.el-message').click(function() {
      $(this).fadeOut();
    });
    var audio = document.getElementById('myAudio');
    var playPauseBtn = $('#playPauseBtn');
    var playPauseBtnMobile = $('.playPauseBtn-mobile');
    var playerIcon = $('.player-icon')
    var source = $('#myAudio source');
    var prevBtn = $('#prevBtn');
    var nextBtn = $('#nextBtn');
    var currentSongDisplay = $('#currentSong');
     var waveform = $('.waveform')
     $.ajax({
       url: "https://nxtcity.nxtbrands.com/frontapi/indexPage/info",
       type: "GET",
       data: {}, 
       dataType: "json", 
       success: function (result) {
         const {data} = result
         const {info, dataVersion,monthcardBenefit} = data
        $('.rules-tips').html(info.lotteryConfig.description)
         // 获取包含换行符的文本
        let textWithNewLines = monthcardBenefit?.equityStatement;
        $('.monthlyRules-button').attr('href', monthcardBenefit.redirectGoodsLink);
        // 替换换行符为 <br> 标签
        let htmlContent = textWithNewLines?.replace(/\n/g, '<br>');
        
        // 设置 HTML 内容
        $('.monthlyRules-text-membership').html(htmlContent);
       const musicList = info.lotteryConfig.backgroundMusic
        const formattedCredit = new Intl.NumberFormat().format(info.lotteryConfig.costCredit);
       $('#requiredPoints').html(`Required points ${formattedCredit} per spin`)
        window.dataVersionId = dataVersion,dataVersionId;
        gif1List(6)
        initReward()
        gif2List(6)
        var currentSongIndex = 0;
        var href = window.location.href;
      
        // 使用正则判断是否包含 show=monthCard
        if (/[\?&]show=monthCard/.test(href)) {
          $('#monthlyRules').show() // 替换为你自己的函数
          var newUrl = href
            .replace(/([?&])show=monthCard(&)?/, function (match, p1, p2) {
              return p1 === '?' && !p2 ? '' : p2 ? p1 : '';
            })
            .replace(/[\?&]$/, ''); // 清理多余 ? 或 &
          window.history.replaceState({}, '', newUrl);
        }

        // 初始设置
        updateCurrentSongDisplay();
        // 自动播放
        // 播放/暂停按钮点击事件
        playPauseBtn.on('click', function() {
          audio.src=  musicList[currentSongIndex].musicUrl
          const hasClass = playPauseBtn.hasClass('play-pause-btn');
          console.log(playPauseBtnMobile)
          playPauseBtn.removeClass('play-pause-btn')
          playPauseBtn.removeClass('play-btn')
          playPauseBtnMobile.removeClass('play-pause-btn')
          playPauseBtnMobile.removeClass('play-btn')
          playerIcon.removeClass('playing')
          waveform.removeClass('waveform-play')
          if (hasClass) {
            waveform.addClass('waveform-play')
            audio.play();
            playPauseBtn.addClass('play-btn')
            playerIcon.addClass('playing')
            playPauseBtnMobile.addClass('play-btn')
          } else {
            audio.pause();
            playPauseBtn.addClass('play-pause-btn')
            playPauseBtnMobile.addClass('play-pause-btn')
          }
        });
      
        // 上一首按钮点击事件
        prevBtn.on('click', function() {
          currentSongIndex = (currentSongIndex - 1 + musicList.length) % musicList.length;
          audio.src = musicList[currentSongIndex].musicUrl
          audio.play();
          playPauseBtn.removeClass('play-pause-btn')
          playPauseBtn.removeClass('play-btn')
          playPauseBtnMobile.removeClass('play-pause-btn')
          playPauseBtnMobile.removeClass('play-btn')
          waveform.removeClass('waveform-play')
          waveform.addClass('waveform-play')
          playerIcon.removeClass('playing')
          playerIcon.addClass('playing')
          playPauseBtn.addClass('play-btn')
          playPauseBtnMobile.addClass('play-btn')
          updateCurrentSongDisplay();
        });
        function playSong(index) {
          if (index < musicList.length) {
            audio.src = musicList[index].musicUrl;
            audio.play();
          }
        }
      
        // 设置音频播放完成后的回调
        audio.addEventListener('ended', function() {
          currentSongIndex = (currentSongIndex + 1) % musicList.length;
          playSong(currentSongIndex);
        });
      
        // 下一首按钮点击事件
        nextBtn.on('click', function() {
          currentSongIndex = (currentSongIndex + 1) % musicList.length;
          audio.src = musicList[currentSongIndex].musicUrl
          audio.play();
          playPauseBtn.removeClass('play-pause-btn')
          playPauseBtn.removeClass('play-btn')
          playPauseBtnMobile.removeClass('play-pause-btn')
          playPauseBtnMobile.removeClass('play-btn')
          playPauseBtn.addClass('play-btn')
          playPauseBtnMobile.addClass('play-btn')
          playerIcon.removeClass('playing')
          playerIcon.addClass('playing')
          waveform.removeClass('waveform-play')
          waveform.addClass('waveform-play')
          updateCurrentSongDisplay();
        });
      
        // 根据播放状态更新按钮文本和样式
        audio.onplay = function() {
          waveform.addClass('waveform-play')
        };
      
        audio.onpause = function() {
          waveform.removeClass('waveform-play')
        };

        // 更新当前歌曲显示
        function updateCurrentSongDisplay() {
          currentSongDisplay.text(musicList[currentSongIndex].musicName);
        }
       }
    })
     var screenWidth = $(window).width(); // 获取屏幕宽度
     var scaleRatio = screenWidth / 2040; // 计算缩放比例
     var contentHeight = scaleRatio * 980
    // 使用jQuery来选取并缩放元素
    $('.lucky').css({
      'transform': 'scale(' + scaleRatio + ')',  // 设置缩放比例
      'transform-origin': '0 0',  // 设置缩放的原点，这里设为左上角
      'width': '2040px',  // 固定元素的宽度为原始宽度
      'height': contentHeight + 'px' // 设置高度自动适应，可以根据需要调整
      
    });
      $('#drawsNumberValue').on('input', function() {
        var value = $(this).val().trim(); // 获取输入框的值并去除首尾空格
        if (value === '') {
          return; // 如果值为空，不进行后续验证
        }
        var text = $('#requiredPoints').text();
        var points = text.match(/\d+/)[0];
        var text = $('#myPoints').text();
        var myPoints = text.match(/\d+/)[0];
        console.log(myPoints/points)
        console.log(myPoints)
       // 将输入值转换为整数
        var intValue = parseInt(value);
        // 检查是否为数字
        if (!isNaN(intValue)) {
          // 如果输入值大于50，将其设置为50
          if (intValue > 50) {
            $(this).val('50');
          }
        } else {
          // 如果不是有效数字，清空输入框或者执行其他逻辑
          $(this).val('');
        }
      });
  });
$(document).ready(function() {
  
  // 设置 .carousel-track 的宽度
  $('.carousel-track').css('width', `${100}%`);
  let currentIndex = 0;
  let numImages = $('.lucky-pc .carousel-track .carousel-item').length;
  const $indicators = $('.carousel-indicators');
  console.log(numImages)
  function showSlide(index) {
    updateIndicators(index)
    const offset = -index * 100;
    $('.carousel-track').css('transform', `translateX(${offset}%)`);
  }
  let autoPlayInterval;
  function updateIndicators(index) {
    $indicators.find('.carousel-indicator').removeClass('active');
    $indicators.find(`.carousel-indicator:eq(${index})`).addClass('active');
  }
  for (let i = 0; i < numImages; i++) {
    $indicators.append('<div class="carousel-indicator"></div>');
  }
  $indicators.find('.carousel-indicator').on('click', function(event) {
    event.preventDefault(); // Prevent default action
    currentIndex = $(this).index();
    showSlide(currentIndex);
    stopAutoPlay();
    startAutoPlay();
  });
  function startAutoPlay() {
    // 如果已经有计时器在运行，不重新启动
    if (!autoPlayInterval) {
      autoPlayInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % numImages;
        showSlide(currentIndex);
      }, 3000); // 每 3 秒切换一次
    }
  }
  
  function stopAutoPlay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null; // 清除计时器 ID
    }
  }
  
  // 获取左右切换按钮
  $('.carousel-prev').on('click', function(event) {
    event.stopPropagation(); // 阻止事件冒泡
    stopAutoPlay(); // Optional: Stop auto-play when manually changing slides
    if (currentIndex > 0) {
    currentIndex--;
    } else {
    currentIndex = numImages - 1; // 循环到最后一张
    }
    showSlide(currentIndex);
    startAutoPlay(); // Restart auto-play
  });

  $('.carousel-next').on('click', function(event) {
    event.stopPropagation(); // 阻止事件冒泡
    stopAutoPlay(); // Optional: Stop auto-play when manually changing slides
    if (currentIndex < numImages - 1) {
      currentIndex++;
    } else {
      currentIndex = 0; // 循环到第一张
    }
    showSlide(currentIndex);
    startAutoPlay(); // Restart auto-play
  });
  
  
  // 鼠标悬停时停止自动播放，离开后重新开始
  $('.carousel-container').on('mouseenter', function() {
    stopAutoPlay();
  }).on('mouseleave', function() {
    startAutoPlay();
  });
  
  // 初始启动自动播放
  startAutoPlay();
  // 其他代码，如自动播放等...
  let startX;
  let currentTranslateX = -200; // 初始位置百分比
  const $track = $('.carousel-track-mobile');

  $track.on('touchstart', function(e) {
    stopAutoPlay();
    e.preventDefault(); // 阻止浏览器默认行为
    startX = e.originalEvent.touches[0].clientX;
  });

 $track.on('touchmove', function(e) {
    stopAutoPlay();
    e.preventDefault();
   const $element = $('.carousel-track-mobile .lucky-left-nameplate-box')[0];
    const width = $element.offsetWidth
    const moveX = e.originalEvent.touches[0].clientX;
    const diffX = startX - moveX;
   console.log($element.width)
    console.log(diffX)
    // Check the direction of the swipe
    if (diffX > 0) {
        // Swipe left
        console.log('Swiping left');
        $track.css('transform', `translateX(${currentTranslateX - diffX - currentIndex* width}px)`);
    } else if (diffX < 0) {
        // Swipe right
        console.log('Swiping right');
        $track.css('transform', `translateX(${0 - diffX - currentIndex* width}px)`);
    }
    // Update the currentTranslateX after applying the transform
});


  $track.on('touchend', function(e) {
    // 可以添加逻辑来确定最终的位置
    e.preventDefault(); // 阻止浏览器默认行为
   const endX = e.originalEvent.changedTouches[0].clientX;
    const diffX = startX - endX;
    const threshold = 50; // Minimum swipe distance to change slide

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        // Swiped left
        if (currentIndex < numImages - 1) {
          currentIndex++;
        } else {
          currentIndex = 0; // Loop back to the first slide
        }
      } else {
        // Swiped right
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = numImages - 1; // Loop back to the last slide
        }
      }
      showSlide(currentIndex);
    }
    startAutoPlay();
  });
});
$(function() {
    const icon = document.querySelector('.player-icon');
    const container = document.querySelector('.player-container');
    const controls = document.querySelector('.player-controls');

    let isDragging = false;
    let clickTimeout;
    const dragThreshold = 10; // 拖动阈值（像素）
    const clickDelay = 200; // 点击延迟（毫秒）

    // 阻止浏览器滚动
    $(window).on('touchmove', function(e) {
        if (isDragging) e.preventDefault();
    });

    // 防止 .player-controls 的点击事件冒泡到 .player-icon
    controls.addEventListener('click', (e) => {
        e.stopPropagation();
    });

    icon.addEventListener('click', (e) => {
        // 如果检测到拖动，则不处理点击事件
        if (!isDragging) {
            e.stopPropagation();
            container.classList.toggle('active');
        }
    });

    var $playerContainer = $('.player-container');

    $playerContainer.on('mousedown touchstart', function(e) {
        e.preventDefault(); // 防止默认事件
        isDragging = false; // 初始化拖动状态
        clickTimeout = setTimeout(() => {
            if (!isDragging) {
                // 点击延迟到达时，处理点击事件
                // 延迟处理逻辑（如果有必要）
            }
        }, clickDelay); // 延迟处理

        const startX = e.pageX || e.originalEvent.touches[0].pageX;
        const startY = e.pageY || e.originalEvent.touches[0].pageY;
        const startRight = parseInt($playerContainer.css('right')) || 0;
        const startLeft = parseInt($playerContainer.css('left')) || 0;
        const startTop = parseInt($playerContainer.css('top')) || 0;
        const startBottom = parseInt($playerContainer.css('bottom')) || 0;

        $(document).on('mousemove touchmove', function(e) {
            clearTimeout(clickTimeout); // 如果开始拖动，清除点击延迟
            const currentX = e.pageX || e.originalEvent.touches[0].pageX;
            const currentY = e.pageY || e.originalEvent.touches[0].pageY;
            const moveX = currentX - startX;
            const moveY = currentY - startY;

            if (Math.abs(moveX) > dragThreshold || Math.abs(moveY) > dragThreshold) {
                isDragging = true; // 超过阈值则视为拖动
            }

            if (isDragging) {
                const containerWidth = $playerContainer.outerWidth();
                const containerHeight = $playerContainer.outerHeight();
                const windowWidth = $(window).width();
                const windowHeight = $(window).height();

                if (startLeft) {
                    let newLeft = startLeft + moveX;
                    if (newLeft < 0) newLeft = 0;
                    if (newLeft > windowWidth - containerWidth) newLeft = windowWidth - containerWidth;
                    $playerContainer.css({ left: newLeft + 'px', right: 'auto' });
                } else if (startRight) {
                    let newRight = startRight - moveX;
                    if (newRight < 0) newRight = 0;
                    if (newRight > windowWidth - containerWidth) newRight = windowWidth - containerWidth;
                    $playerContainer.css({ right: newRight + 'px', left: 'auto' });
                }

                if (startTop) {
                    let newTop = startTop + moveY;
                    if (newTop < 0) newTop = 0;
                    if (newTop > windowHeight - containerHeight) newTop = windowHeight - containerHeight;
                    $playerContainer.css({ top: newTop + 'px', bottom: 'auto' });
                } else if (startBottom) {
                    let newBottom = startBottom - moveY;
                    if (newBottom < 0) newBottom = 0;
                    if (newBottom > windowHeight - containerHeight) newBottom = windowHeight - containerHeight;
                    $playerContainer.css({ bottom: newBottom + 'px', top: 'auto' });
                }
            }
        });

        $(document).on('mouseup touchend', function(e) {
            $(document).off('mousemove touchmove');
            $(document).off('mouseup touchend');
            if (!isDragging) {
                clearTimeout(clickTimeout);
                var playPauseBtn = $('#playPauseBtn');
                var prevBtn = $('#prevBtn');
                var nextBtn = $('#nextBtn');

                if (e.target.classList.contains('player-icon') || e.target.classList.contains('player-icon playing')) {
                    icon.click(); // 手动触发点击事件
                }
                if (e.target.classList.contains('pase-show') || e.target.classList.contains('play-show')) {
                    playPauseBtn.click(); // 手动触发点击事件
                }
                if (e.target.classList.contains('pase-left')) {
                    nextBtn.click(); // 手动触发点击事件
                }
                if (e.target.classList.contains('pase-right')) {
                    prevBtn.click(); // 手动触发点击事件
                }
            }
            isDragging = false; // 确保拖动状态被重置
        });
    });
});

$(document).ready(function() {
    const options = ['Bets 01', 'Bets 02', 'Bets 03', 'Bets 04', 'Bets 05', 'Bets 10', 'Bets 20', 'Bets 30', 'Bets 40', 'Bets 50'];
    let isDragging = false;
    let startY, scrollTop;
    
    // 当鼠标按下时开始拖动
    $('#picker-options').on('mousedown', function(e) {
      e.preventDefault(); // 防止默认事件
      isDragging = true;
      startY = e.pageY - $(this).offset().top;
      scrollTop = $(this).scrollTop();
      $(this).addClass('dragging');
    });
    
    // 当鼠标移动时进行拖动
    $(document).on('mousemove', function(e) {
      if (!isDragging) return;
      e.preventDefault();
      const y = e.pageY - $('#picker-options').offset().top;
      const walk = (y - startY) * 2; // 2 是拖动速度，可以调整
      $('#picker-options').scrollTop(scrollTop - walk);
    });
    
    // 当鼠标松开时停止拖动
    $(document).on('mouseup', function() {
      isDragging = false;
      $('#picker-options').removeClass('dragging');
    });

    function populateOptions() {
        const $pickerOptions = $('#picker-options');
        $pickerOptions.empty();
        options.forEach(option => {
            $pickerOptions.append(`<li><span>${option}</span></li>`);
        });
    }

    function openPicker() {
        $('#picker').removeClass('hidden');
        centerSelectedOption();
    }

    function closePicker() {
        $('#picker').addClass('hidden');
    }

    function confirmSelection() {
        const selectedOption = $('#picker-options li.selected').text();
        alert('You selected: ' + selectedOption);
        closePicker();
    }

    function centerSelectedOption() {
        const $pickerOptions = $('#picker-options');
        const $options = $pickerOptions.find('li');
        const centerPosition = $pickerOptions.height() / 2 + 10;

        let closest = null;
        let closestDistance = Infinity;

        $options.each(function() {
            const $option = $(this);
            const offset = $option.offset().top - $pickerOptions.offset().top;
            const optionCenter = offset + $option.height() / 2;
            const distance = Math.abs(centerPosition - optionCenter);
            if (distance < closestDistance) {
                closestDistance = distance;
                closest = $option;
            }
        });

        if (closest) {
            $('#picker-options li').removeClass('selected');
            closest.addClass('selected');
        }
    }

    populateOptions();
    openPicker();

    $('#picker-options').on('scroll', function() {
        centerSelectedOption();
    });
    $('#picker').on('click', '.picker-header button', function() {
        confirmSelection();
    });
});

// 日历
$(document).ready(function() {
  const $prevMonthBtn = $('#prevMonth');
  const $nextMonthBtn = $('#nextMonth');
  const $monthYearElem = $('#monthYear');
  const $daysElem = $('#days');

  let currentDate = new Date(); // 当前日期
  let currentMonth = currentDate.getMonth();
  let currentYear = currentDate.getFullYear();

  function addCreditDiv() {
      $('#days .date').each(function() {
          const creditDiv = $('<div class="credit">CREDITS<br/><span style="font-size: 20px;font-weight: bold;">100</span></div>');
          $(this).before(creditDiv);
      });
  }

  function formatDate(date) {
      return date.toLocaleDateString('zh-CN', { day: '2-digit', month: '2-digit' });
  }

  function renderCalendar() {
      const isWideScreen = $(window).width() > 540;
      $daysElem.empty();

      if (isWideScreen) {
          // 加载月数据
          const firstDay = new Date(currentYear, currentMonth, 1).getDay();
          const lastDate = new Date(currentYear, currentMonth + 1, 0).getDate();

          $monthYearElem.text(`${currentYear}-${currentMonth + 1}`);

          let startDate = new Date(currentYear, currentMonth, 1 - firstDay);
          let endDate = new Date(currentYear, currentMonth + 1, 0);
          endDate.setDate(endDate.getDate() + (6 - endDate.getDay()));

          for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
              addDateElement(date);
          }
      } else {
          let date = new Date(currentDate);
          // 获取当前的年份和月份（月份+1）
          $monthYearElem.text(`${date.getFullYear()}-${date.getMonth() + 1}`);

          for (let i = 0; i < 7; i++) {
              date.setDate(currentDate.getDate() + i);
              addDateElement(date);
          }
      }
      addCreditDiv();
      checkInit();
  }

  function addDateElement(date) {
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedDay = String(date.getDate()).padStart(2, '0');
      const time = `${date.getFullYear()}-${formattedMonth}-${formattedDay}`;
      const htmlItem = $(`<div class="date" data-date="${time}">${formatDate(date)}</div>`);
      // 获取星期几的英文表示
      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const weekDayIndex = date.getDay(); // 0 (星期天) 到 6 (星期六)
      const weekDay = weekdays[weekDayIndex];
      
      // 创建 dayElem 并添加 data-week 属性
      const dayElem = $('<div></div>')
        .html(htmlItem)
        .attr('data-week', weekDay);
      if (date.getMonth() !== currentMonth) {
          dayElem.addClass('empty');
      } else if (date.toDateString() === new Date().toDateString()) {
          const TodayItem = $(`<div data-date="${time}" class="date">Today</div>`);
          dayElem.attr('onclick', `signClick('${time}', 'today')`);
          dayElem.addClass('today').html(TodayItem);
      }
      $daysElem.append(dayElem);
  }

  $prevMonthBtn.click(function() {
      const isWideScreen = $(window).width() > 540;
      if (isWideScreen) {
          // 月视图切换
          if (currentMonth === 0) {
              currentMonth = 11;
              currentYear--;
          } else {
              currentMonth--;
          }
      } else {
          // 周视图切换
          currentDate.setDate(currentDate.getDate() - 7);
      }
      renderCalendar();
  });

  $nextMonthBtn.click(function() {
      const isWideScreen = $(window).width() > 540;
      if (isWideScreen) {
          // 月视图切换
          if (currentMonth === 11) {
              currentMonth = 0;
              currentYear++;
          } else {
              currentMonth++;
          }
      } else {
          // 周视图切换
          currentDate.setDate(currentDate.getDate() + 7);
      }
      renderCalendar();
  });

  renderCalendar(); // 初始化渲染
});


$(document).ready(function() {
  const list = document.querySelector('.continuousSignature-list');
  const wrapper = document.querySelector('.continuousSignature-wrapper');
  let offset = 0;
  document.querySelector('.arrow-up').addEventListener('click', () => {
    offset += 120;
    if (offset > 0) offset = 0; // 不允许超出顶部
    list.style.transform = `translateY(${offset}px)`;
  });
  
  document.querySelector('.arrow-down').addEventListener('click', () => {
    offset -= 120;
    const maxOffset = list.scrollHeight - wrapper.clientHeight;
    console.log(wrapper.scrollHeight)
    console.log(maxOffset)
    if (offset < -maxOffset) offset = -maxOffset; // 不允许超出底部
    list.style.transform = `translateY(${offset}px)`;
  });
});


/* Accessibility fixes for Lucky Draw dynamic UI */
(function () {
  var dialogLabels = {
    congratulations: 'Lucky draw result',
    giftList: 'Your prize',
    'mobile-prize': 'My prizes',
    rules: 'Game rules and reward details',
    monthlyRules: 'Membership benefits',
    drawsNumber: 'Number of lucky draw selections',
    drawsNumber2: 'Number of lucky draw spins',
    buyCredits: 'Get more credits',
    checkIn: 'NXT premium resident check-in',
    visaCard: 'Sign-in card',
    tips: 'Message',
    'pc-share': 'Share your prize'
  };

  function getCleanText(el) {
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function setAttributeIfChanged(el, name, value) {
    if (!el) return;

    var nextValue = String(value);

    if (el.getAttribute(name) !== nextValue) {
      el.setAttribute(name, nextValue);
    }
  }

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function makeKeyboardClickable(el, label) {
    if (!el || el.tagName === 'A' || el.tagName === 'BUTTON' || el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA') {
      return;
    }

    if (!el.hasAttribute('role')) {
      el.setAttribute('role', 'button');
    }

    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    if (label && !el.hasAttribute('aria-label')) {
      el.setAttribute('aria-label', label);
    }

    if (!el.dataset.a11yKeyboardBound) {
      el.dataset.a11yKeyboardBound = 'true';

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          el.click();
        }
      });
    }
  }

  function setLabel(el, label) {
    if (el && label && !el.hasAttribute('aria-label')) {
      el.setAttribute('aria-label', label);
    }
  }

  function hideDecorativeImage(img) {
    if (!img) return;
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');
  }

  function fixDialogs() {
    document.querySelectorAll('.lucky-dialog').forEach(function (dialog) {
      var id = dialog.id || '';
      var isVisible = isElementVisible(dialog);

      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('tabindex', '-1');
      dialog.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) {
        dialog.setAttribute('aria-label', dialogLabels[id] || 'Dialog');
      }
    });
  }

  function fixButtons() {
    document.querySelectorAll('.modal-content-close').forEach(function (closeBtn) {
      makeKeyboardClickable(closeBtn, 'Close dialog');
      closeBtn.querySelectorAll('img').forEach(hideDecorativeImage);
    });

    document.querySelectorAll(
      '.congratulations-button, .drawsNumber-item, .drawsNumber-button, .visaCard-button-group, .rules-title, .giftList-left, .giftList-right, .arrow, .carousel-prev, .carousel-next, .carousel-indicator, .lucky-tag-item, .lucky-gift1-title-right-item, #playPauseBtn, .playPauseBtn-mobile, #prevBtn, #nextBtn, .player-icon'
    ).forEach(function (el) {
      makeKeyboardClickable(el, getCleanText(el) || el.getAttribute('aria-label') || 'Button');
    });

    setLabel(document.querySelector('#prevBtn'), 'Previous song');
    setLabel(document.querySelector('#nextBtn'), 'Next song');
    setLabel(document.querySelector('#playPauseBtn'), 'Play or pause music');
    document.querySelectorAll('.playPauseBtn-mobile').forEach(function (el) {
      setLabel(el, 'Play or pause music');
    });
    setLabel(document.querySelector('.player-icon'), 'Open music player');

    setLabel(document.querySelector('#prevMonth'), 'Previous month');
    setLabel(document.querySelector('#nextMonth'), 'Next month');

    document.querySelectorAll('#days > div.today, #days > div.addSign, #days > div.addSignModal').forEach(function (el) {
      var date = el.querySelector('.date');
      var dateText = date ? (date.getAttribute('data-date') || getCleanText(date)) : getCleanText(el);
      makeKeyboardClickable(el, dateText ? 'Check in for ' + dateText : 'Check in');
    });
  }

  function fixTabs() {
    document.querySelectorAll('.modal-tag').forEach(function (tabList) {
      setAttributeIfChanged(tabList, 'role', 'tablist');

      tabList.querySelectorAll('.modal-item').forEach(function (item, index) {
        var isActive = item.classList.contains('active');

        setAttributeIfChanged(item, 'role', 'tab');
        setAttributeIfChanged(item, 'tabindex', isActive ? '0' : '-1');
        setAttributeIfChanged(item, 'aria-selected', isActive ? 'true' : 'false');

        if (!item.hasAttribute('aria-label')) {
          item.setAttribute('aria-label', getCleanText(item) || 'Tab ' + (index + 1));
        }

        if (!item.dataset.a11yTabBound) {
          item.dataset.a11yTabBound = 'true';

          item.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              item.click();
            }
          });
        }
      });
    });
  }

  function fixInputsAndStatus() {
    var message = document.querySelector('.el-message');
    if (message) {
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
    }

    var drawsInput = document.querySelector('#drawsNumberValue');
    if (drawsInput) {
      drawsInput.setAttribute('aria-label', 'Number of lucky draw spins');
      drawsInput.setAttribute('inputmode', 'numeric');
      drawsInput.setAttribute('pattern', '[0-9]*');
    }

    var picker = document.querySelector('#picker-options');
    if (picker) {
      picker.setAttribute('role', 'listbox');
      picker.setAttribute('aria-label', 'Lucky draw spin options');

      picker.querySelectorAll('li').forEach(function (item) {
        setAttributeIfChanged(item, 'role', 'option');
        setAttributeIfChanged(item, 'tabindex', '0');
        setAttributeIfChanged(
          item,
          'aria-selected',
          item.classList.contains('selected') ? 'true' : 'false'
        );

        if (!item.dataset.a11yOptionBound) {
          item.dataset.a11yOptionBound = 'true';

          item.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              item.click();
            }
          });
        }
      });
    }
  }

  function fixLinksAndImages() {
    document.querySelectorAll('.share-button a').forEach(function (link) {
      if (!link.hasAttribute('aria-label')) {
        if (link.href.indexOf('facebook.com') > -1) {
          link.setAttribute('aria-label', 'Share to Facebook');
        } else if (link.href.indexOf('twitter.com') > -1) {
          link.setAttribute('aria-label', 'Share to Twitter');
        } else {
          link.setAttribute('aria-label', getCleanText(link) || 'Share');
        }
      }

      link.querySelectorAll('img').forEach(hideDecorativeImage);
    });

    document.querySelectorAll('.modal-content-close img, .drawsNumber-images img, .buyCredits-images img, .congratulations-item img, .giftList-left img, .giftList-right img').forEach(hideDecorativeImage);

    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function fixDynamicCards() {
    document.querySelectorAll('.lucky-prize-item[onclick], .my-prize-list-item[onclick], .giftList-item, .buyCredits-item').forEach(function (card) {
      var label = getCleanText(card);

      if (card.tagName === 'A') {
        setLabel(card, label || 'Open item');
      } else {
        makeKeyboardClickable(card, label || 'Open item');
      }
    });

    document.querySelectorAll('.lucky-prize-image, .my-prize-list-image, .giftList-image, .rules-item-image, .lucky-gift1-item').forEach(function (imageBox) {
      var parentText = getCleanText(imageBox.parentElement);
      if (parentText) {
        imageBox.setAttribute('role', 'img');
        imageBox.setAttribute('aria-label', parentText);
      } else {
        imageBox.setAttribute('aria-hidden', 'true');
      }
    });

    document.querySelectorAll('.carousel-container').forEach(function (carousel) {
      carousel.setAttribute('role', 'region');
      setLabel(carousel, 'Lucky draw carousel');
    });

    document.querySelectorAll('.carousel-indicator').forEach(function (indicator, index) {
      setLabel(indicator, 'Go to slide ' + (index + 1));
      indicator.setAttribute('aria-current', indicator.classList.contains('active') ? 'true' : 'false');
    });
  }

  function syncLuckyDrawA11y() {
    fixDialogs();
    fixButtons();
    fixTabs();
    fixInputsAndStatus();
    fixLinksAndImages();
    fixDynamicCards();
  }

  window.syncLuckyDrawA11y = syncLuckyDrawA11y;

  function initLuckyDrawA11y() {
    var observer;
    var syncScheduled = false;
    var isSyncing = false;

    function startObserving() {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    function runSafeSync() {
      if (isSyncing) return;

      isSyncing = true;
      observer.disconnect();

      try {
        syncLuckyDrawA11y();
      } finally {
        isSyncing = false;
        startObserving();
      }
    }

    observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type === 'childList') {
          return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
        }

        if (mutation.type !== 'attributes') {
          return false;
        }

        if (mutation.attributeName === 'class') {
          return true;
        }

        if (mutation.attributeName === 'style') {
          var target = mutation.target;

          return (
            target.classList.contains('lucky-dialog') ||
            target.classList.contains('modal-content') ||
            Boolean(target.closest('.lucky-dialog'))
          );
        }

        return false;
      });

      if (!shouldSync || syncScheduled) return;

      syncScheduled = true;

      window.requestAnimationFrame(function () {
        syncScheduled = false;
        runSafeSync();
      });
    });

    runSafeSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuckyDrawA11y);
  } else {
    initLuckyDrawA11y();
  }
})();

